(function () {
  if (window.__productSectionVideos) return;
  window.__productSectionVideos = true;

  function init(root) {
    if (!root || root.dataset.bound === 'true') return;
    var frame = root.querySelector('[data-video-frame]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-video-id]'));
    if (!frame || !items.length) return;
    root.dataset.bound = 'true';

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var id = item.getAttribute('data-video-id');
        var title = item.getAttribute('data-video-title') || '';
        if (!id) return;
        items.forEach(function (other) {
          other.classList.toggle('is-active', other === item);
        });
        frame.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?rel=0&modestbranding=1';
        frame.title = title;
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-product-section-videos]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
